import { Controller } from "@hotwired/stimulus";
import "selectize";
import "selectize/dist/css/selectize.css";

export default class extends Controller {
  connect() {
    this.initializeSelectize();
  }

  initializeSelectize() {
    const element = this.element;
    $(element).selectize({
      create: false,
      sortField: "text",
      plugins: ["remove_button"],
      hideSelected: true,
    });
  }

  disconnect() {
    const selectizeInstance = $(this.element)[0].selectize;
    if (selectizeInstance) {
      selectizeInstance.destroy();
    }
  }
}
